import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-sign-in-step-welcome',
  templateUrl: './sign-in-step-welcome.component.html',
  styleUrls: ['./sign-in-step-welcome.component.scss'],
})
export class SignInStepWelcomeComponent {
  @Input() googleRequest: any;

  @Output() goToStep = new EventEmitter<number>();
  @Output() signUpWithFB = new EventEmitter<void>();
  @Output() goToLegal = new EventEmitter<void>();
  @Output() openLoginModal = new EventEmitter<void>();
}
